import { Collapse } from "@/pages/aigc/components/Collapse";
import SvgIcon from "@home/components/SvgIcon";
import classNames from "classnames";
import React, { memo, useCallback, useMemo, useState } from "react";
import { MainContentCmp } from ".";

interface IDataDescriptionCmpProps<S = string> {
  value?: S;
  title?: S;
  type?: S;
  answer?: any[];
}

// 数据来源与说明区域（同时适用于 data_description 和 complete_summary）
export const DataDescriptionCmp = memo((props: IDataDescriptionCmpProps) => {
  const { title, value, type, answer } = props || {};
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleToggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  // 此段代码, 判断上一段text是否以图表结尾, 如果返回true, 则margin设置为0, 默认20px
  const shouldApplySpecialStyle = useMemo(() => {
    if (!answer || !Array.isArray(answer)) return false;

    // 找到当前项在answer中的索引（兼容 data_description 和 complete_summary）
    const currentIndex = answer.findIndex(item => item.type === type);

    // 如果找不到当前项或者当前项是第一个元素，返回false
    if (currentIndex <= 0) return false;

    // 获取前一项
    const previousItem = answer[currentIndex - 1];

    // 检查前一项是否为text类型且value以</databraindata>或</dbd>结尾
    if (previousItem?.type === 'text' && typeof previousItem?.value === 'string') {
      const trimmedValue = previousItem.value.trim();
      return trimmedValue.endsWith('</databraindata>') || trimmedValue.endsWith('</dbd>');
    }

    return false;
  }, [answer]);

  return (
    <div className={
      classNames('dba-data-description-container', {
        'dba-data-description-open': !isOpen,
        'dba-data-description-special': shouldApplySpecialStyle,
      })
    }>
      <div
        className="dba-data-description-header"
        onClick={handleToggle}
      >
        <span className="dba-data-description-title">{title}<SvgIcon type={isOpen ? 'point-top' : 'point-down'} /></span>
      </div>
      <Collapse isOpen={isOpen}>
        {isOpen && <div className="dba-data-description-content">
          <MainContentCmp
            value={value}
            answer={answer}
            className="dba-data-description-markdown"
            isShowReference={false}
          />
        </div>}
      </Collapse>
    </div>
  );
}, (prevProps, nextProps) => {
  // 当value和title都一致时，不重新渲染
  return prevProps.value === nextProps.value;
});